// extracted by mini-css-extract-plugin
module.exports = {"rootMenu":"dropdown-menu_rootMenu__9OXqQ","menu":"dropdown-menu_menu__jRTi8","menuItem":"dropdown-menu_menuItem__yz8Tk","disabled":"dropdown-menu_disabled__9MNo7"};